function withoutTrailingSlash(url: string) {
  return url.replace(/\/+$/, "");
}

function getLegacyAppBaseUrl() {
  const configuredUrl = import.meta.env.VITE_LEGACY_APP_BASE_URL;
  if (configuredUrl) return withoutTrailingSlash(configuredUrl);

  if (import.meta.env.DEV) return "http://localhost:5173";
  if (import.meta.env.VITE_DEPLOY_ENVIRONMENT === "prod") {
    return "https://app.assetwatch.com";
  }

  const environment = import.meta.env.VITE_DEPLOY_ENVIRONMENT ?? "dev";
  const branch = import.meta.env.VITE_BRANCH_NAME ?? "dev";
  return `https://${branch}.${environment}.assetwatch.com`;
}

export function getLegacyCustomerTabUrl(
  externalCustomerId: string,
  tab: string,
  facilityIds = "",
) {
  const url = new URL(
    `/customers/${encodeURIComponent(externalCustomerId)}/${tab}`,
    getLegacyAppBaseUrl(),
  );
  if (facilityIds) url.searchParams.set("fid", facilityIds);
  return url.toString();
}
